import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { CircleHelp } from 'lucide-react';
import { useFeedback } from '@/contexts/useFeedbackChat';
import { useIsMobile } from '@/hooks/use-mobile';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogClose } from "@/components/ui/dialog";
interface HelpContentType {
  title: string;
  description: string;
  content: React.ReactNode;
}
interface TechniquesHeaderProps {
  helpContent?: HelpContentType;
}
export const TechniquesHeader: React.FC<TechniquesHeaderProps> = ({
  helpContent
}) => {
  const {
    openFeedback
  } = useFeedback();
  const isMobile = useIsMobile();
  const [helpOpen, setHelpOpen] = useState(false);
  const handleRequestTechnique = () => {
    openFeedback('Technique Request');
  };
  return <div className="space-y-4">
      {!isMobile && <>
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight inline-flex items-center gap-2">
              Technique Library
              {helpContent && <CircleHelp className="h-5 w-5 text-primary cursor-pointer hover:text-primary/80 transition-colors" onClick={() => setHelpOpen(true)} strokeWidth={2} />}
            </h1>

            <div className="flex flex-col sm:flex-row gap-2">
              <Button variant="default" size="sm" type="button" onClick={handleRequestTechnique} className="request-technique-btn shadow-sm">
                Request Technique
              </Button>
            </div>
          </div>
        </>}
      
      {isMobile && <div className="flex justify-center">
          <Button variant="default" size="sm" type="button" onClick={handleRequestTechnique} className="request-technique-btn shadow-sm">
            Request Technique
          </Button>
        </div>}
      
      {helpContent && <Dialog open={helpOpen} onOpenChange={setHelpOpen}>
          <DialogContent className="sm:max-w-md">
            <DialogHeader>
              <DialogTitle>{helpContent.title}</DialogTitle>
              <DialogDescription>
                {helpContent.description}
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4">
              {helpContent.content}
            </div>
            <div className="flex justify-end">
              <DialogClose asChild>
                <Button variant="default" size="sm">Got it</Button>
              </DialogClose>
            </div>
          </DialogContent>
        </Dialog>}
    </div>;
};